import React, { Component } from "react";

// Components
import SearchFilter from "../../CustomUIComponents/SearchFilter/SearchFilter";
import Pagination from "../../CustomUIComponents/Pagination/Pagination";
import CheckboxComponent from "../../CustomUIComponents/CheckboxComponent/CheckboxComponent";

// Strings
import { Strings } from "../../../resources/i18n/i18n";
import { Button, Col, Row } from "react-bootstrap";
import { Card, Typography } from "@mui/material";
import _ from "lodash";

// Constants
import { DEFAULT_TYPE_OF_CUSTOMER_SELECTION, MINIMART_GRADE, MINIMART_LEVELS, MINIMART_MANAGEMENT_TYPE_OF_CUSTOMER, MINIMART_REGISTRATION_STATUS, MINIMART_STATUSES, MINIMART_TYPE, SEARCH_FILTER_FIELDS, SEARCH_FILTER_TYPE } from "../../../constants/appConstants";
import { DEFAULT_MESSENGER_ZONE, DEFAULT_ZONE, GET_DEFAULT_ZONE_SELECTION } from "../../BranchList/BranchListConstants";
import { IS_SCALA_REGISTERED, MINIMART_SUB_TYPES } from "../../MinimartList/Constants";
import { IS_WHATSAPP_NUMBER, WHATSAPP_MINIMART_LIST_COLUMNS } from "../Constants";
import { DEFAULT_PAGINATION_ACTIVE_PAGE, DEFAULT_PAGINATION_RECORDS_COUNT } from "../../CustomUIComponents/Pagination/PaginationConstants";

// Assets
import whatsapp_icon from "../../../resources/images/whatsapp_icon.svg";
class WhatsappMinimartList extends Component {
    constructor(props) {
        super(props);
        this.columns = WHATSAPP_MINIMART_LIST_COLUMNS;
        this.state = {
            selectedRows: [],
            selectAll: false,
            rows: this.props.rows,
            zones: this.props.zones,
            mZones: this.props.mZones,
            matricesId: "",
            ciId: "",
            minimartName: "",
            zone: "",
            messengerZone: "",
            supplierType: "ALL",
            minimartStatus: "",
            businessType: "",
            handleGradeChange: "",
            registrationStatus: "",
            typeOfCustomer: "",
            messengerZones: "",
            recordsPerPage: 10,
            isWhatsappNumber: ""
        }
    }
    componentDidMount() {
        this.handleOnClickSearchFilter(true)
    }
    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.zones, this.props.zones)) {
            this.setState({ zones: this.props.zones });
        }
        if (!_.isEqual(prevProps.mZones, this.props.mZones)) {
            this.setState({ mZones: this.props.mZones });
        }
        if (!_.isEqual(prevProps.rows, this.props.rows)) {
            this.setState({ rows: this.props.rows });
        }
    }
    handleSearchNameChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    handleSearchCICodeChange = (event) => {
        this.setState({ ciId: event.target.value });
    };

    handlesupplierTypeChange = (event) => {
        this.setState({
            supplierType: event.target.value,
        });
    };

    handleStatusChange = (event) => {
        this.setState({
            minimartStatus:
                event.target.value !== Strings("SelectStatus")
                    ? event.target.value
                    : "",
        });
    };

    handleSearchMatricesIdChange = (event) => {
        this.setState({ matricesId: event.target.value });
    };

    handleLevelChange = (event) => {
        this.setState({
            level:
                event.target.value === Strings("minimartLevel")
                    ? ""
                    : event.target.value,
        });
    };

    handleGradeChange = (event) => {
        if (event.target.value !== Strings("selectMiniMartGrade")) {
            this.setState({ grade: event.target.value });
        } else {
            this.setState({
                grade: "",
            });
        }
    };

    handleSelectedZoneChange = (event) => {
        if (
            event.target.value !== DEFAULT_ZONE ||
            event.target.value !== DEFAULT_MESSENGER_ZONE
        ) {
            this.setState({
                [event.target.name]: event.target.value,
                zonelist: [],
            });
        } else {
            this.setState({ [event.target.name]: "", zonelist: [] });
        }
    };

    handleTypeOfCustomerChange = (event) => {
        if (
            event.target.value !== DEFAULT_TYPE_OF_CUSTOMER_SELECTION.label
        ) {
            this.setState({
                typeOfCustomer: event.target.value,
            });
        } else {
            this.setState({ typeOfCustomer: "" });
        }
    };

    handleBusinessTypeChange = (event) => {
        this.setState({
            businessType:
                event.target.value !== Strings("BusinessType")
                    ? event.target.value
                    : "",
        });
    };

    handleRegistrationStatusChange = (event) => {
        this.setState({
            registrationStatus:
                event.target.value !== Strings("registrationStatus")
                    ? event.target.value
                    : "",
        });
    };

    handleScalaRegistrationFlag = (event) => {
        this.setState({
            isScalaRegistered:
                event.target.value !== "AllMinimarts"
                    ? event.target.value
                    : null,
        });

    }

    handleWhatsappNumberFlag = (event) => {
        this.setState({
            isWhatsappNumber:
                event.target.value !== "AllMinimarts"
                    ? event.target.value
                    : null,
        });

    }

    handleMinimartSubTypeChange = (event) => {
        this.setState({
            subType:
                event.target.value !== "subType"
                    ? event.target.value
                    : null,
        })
    }

    onPageChange = ({ page, pageLength }) => {
        this.setState(
            {
                activePage: page,
                recordsPerPage: pageLength,
            },
            () => this.handleOnClickSearchFilter(false)
        );
    };

    resetSearchValues = () => {
        this.setState(
            {
                ciId: "",
                matricesId: "",
                level: "",
                zone: "",
                messengerZone: "",
                grade: "",
                typeOfCustomer: "",
                minimartName: "",
                supplierType: "ALL",
                businessType: "",
                minimartStatus: "",
                registrationStatus: "",
                cedulaId: "",
                recordsPerPage: DEFAULT_PAGINATION_RECORDS_COUNT,
                activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
                zonelist: [],
                isScalaRegistered: null,
                subType: null,
                isWhatsappNumber:""
            },
            () => {
                this.handleOnClickSearchFilter(true);
            }
        );
    };
    handleOnClickSearchFilter = (isDefaultOffset) => {
        isDefaultOffset &&
            this.setState({ activePage: DEFAULT_PAGINATION_ACTIVE_PAGE });
        this.props.handleOnClickSearchFilter({
            search: {
                minimartName: this.state.minimartName,
                zone:
                    this.state.zone !== DEFAULT_ZONE ? this.state.zone : null,
                messengerZone:
                    this.state.messengerZone !== DEFAULT_MESSENGER_ZONE
                        ? this.state.messengerZone
                        : null,
                ciId: this.state.ciId,
                matricesId:
                    this.state.matricesId !== ""
                        ? this.state.matricesId
                        : undefined,
                level: this.state.level !== "" ? this.state.level : undefined,
                type: this.state.typeOfCustomer,
                supplierType: this.state.supplierType,
                grade: this.state.grade,
                businessType: this.state.businessType,
                minimartStatus: this.state.minimartStatus,
                registrationStatus: this.state.registrationStatus,
                cedulaId: this.state.cedulaId,
                zones:
                    (this.state.zonelist && this.state.zonelist.length === 0) ||
                        this.state.zonelist === null
                        ? undefined
                        : this.state.zonelist,
                messengerZones:
                    (this.state.messengerZones && this.state.messengerZones.length === 0) ||
                        this.state.messengerZones === null
                        ? undefined
                        : this.state.messengerZones,
                isScalaRegistered: this.state.isScalaRegistered || undefined,
                subType: this.state.subType || undefined,
                whatsappUser: this.state.isWhatsappNumber || undefined
            },
            pagination: {
                limit: this.state.recordsPerPage,
                offset: isDefaultOffset
                    ? DEFAULT_PAGINATION_ACTIVE_PAGE
                    : this.state.activePage,
            },
        });
    };

    renderSearchFilter = () => {
        let typeOfCustomer = [...MINIMART_MANAGEMENT_TYPE_OF_CUSTOMER];
        typeOfCustomer[0].value !== "" &&
            typeOfCustomer.unshift(DEFAULT_TYPE_OF_CUSTOMER_SELECTION);

        let zones = this.state.zones?.map((singleZone) => {
            return singleZone.name === DEFAULT_ZONE
                ? {
                    label: GET_DEFAULT_ZONE_SELECTION().name,
                    name: GET_DEFAULT_ZONE_SELECTION().name,
                }
                : {
                    label: singleZone.name,
                    name: singleZone.name,
                };
        });
        let mZones = this.state.mZones?.map((singleZone) => {
            return singleZone.name === DEFAULT_ZONE
                ? {
                    label: GET_DEFAULT_ZONE_SELECTION().name,
                    name: GET_DEFAULT_ZONE_SELECTION().name,
                }
                : {
                    label: singleZone.name,
                    name: singleZone.name,
                };
        });
        const minimartFilters = [
            {
                type: SEARCH_FILTER_TYPE.INPUT,
                searchPlaceHolder: Strings("MatricesID"),
                handleOnChange: this.handleSearchMatricesIdChange,
                Value: this.state.matricesId,
                inputType: SEARCH_FILTER_TYPE.NUMBER,
                fieldname: "matricesId",
            },
            {
                type: SEARCH_FILTER_TYPE.INPUT,
                searchPlaceHolder: Strings("code"),
                handleOnChange: this.handleSearchCICodeChange,
                Value: this.state.ciId,
                fieldname: "ciId",
            },
            {
                type: SEARCH_FILTER_TYPE.INPUT,
                searchPlaceHolder: Strings("name"),
                handleOnChange: this.handleSearchNameChange,
                Value: this.state.minimartName,
                fieldname: "minimartName",
                name: "minimartName",
            },
            {
                type: SEARCH_FILTER_TYPE.INPUT,
                searchPlaceHolder: Strings("ownerCedulaNumber"),
                handleOnChange: this.handleSearchNameChange,
                Value: this.state.cedulaId,
                fieldname: SEARCH_FILTER_FIELDS.CEDULA_ID,
                name: "cedulaId",
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleLevelChange,
                Value: this.state.level,
                fieldname: "level",
                filterDropdownList: MINIMART_LEVELS,
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleGradeChange,
                Value: this.state.grade,
                fieldname: "grade",
                filterDropdownList: MINIMART_GRADE,
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleSelectedZoneChange,
                Value: this.state.zone,
                fieldname: SEARCH_FILTER_FIELDS.ZONE,
                name: "zone",
                filterDropdownList: zones,
                paddingTop: 2
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleSelectedZoneChange,
                Value: this.state.messengerZone,
                fieldname: SEARCH_FILTER_FIELDS.MZONE,
                name: "messengerZone",
                filterDropdownList: mZones,
                paddingTop: 2
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handlesupplierTypeChange,
                Value: this.state.supplierType,
                fieldname: "supplierType",
                filterDropdownList: MINIMART_TYPE,
                paddingTop: 2
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleStatusChange,
                Value: this.state.minimartStatus,
                fieldname: "minimartStatus",
                filterDropdownList: MINIMART_STATUSES,
                paddingTop: 2
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleBusinessTypeChange,
                Value: this.state.businessType,
                fieldname: "businessType",
                filterDropdownList: this.props.businessTypeList,
                paddingTop: 2
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleScalaRegistrationFlag,
                Value: this.state.isScalaRegistered,
                fieldname: "isScalaRegistered",
                filterDropdownList: IS_SCALA_REGISTERED,
                paddingTop: 2
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleMinimartSubTypeChange,
                Value: this.state.subType,
                fieldname: "subType",
                filterDropdownList: MINIMART_SUB_TYPES,
                paddingTop: 2
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleTypeOfCustomerChange,
                Value: this.state.typeOfCustomer,
                fieldname: "typeOfCustomer",
                filterDropdownList: typeOfCustomer,
                paddingTop: 2
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleRegistrationStatusChange,
                Value: this.state.registrationStatus,
                fieldname: "registrationStatus",
                filterDropdownList: MINIMART_REGISTRATION_STATUS,
                paddingTop: 2
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleWhatsappNumberFlag,
                Value: this.state.isWhatsappNumber,
                fieldname: "isWhatsappNumber",
                filterDropdownList: IS_WHATSAPP_NUMBER,
                paddingTop: 2
            },
        ];

        return (
            <>
                <Row className='filters'>
                    <SearchFilter
                        filters={minimartFilters}
                        handleOnClickSearchFilter={this.handleOnClickSearchFilter}
                        handleOnClickResetFilter={this.resetSearchValues}
                        paddingLeft={3}
                        paddingTop={2}
                        removeLeftPadding={true}
                    />
                </Row>
                {this.props.errorMessage !== "" ? (
                    <Row className='errors'>
                        {Strings(this.props.errorMessage)}
                    </Row>
                ) : null}
                {this.state.zonelist && this.state.zonelist.length > 1 && (
                    <Row className='pt-2'>
                        <Col md={12} className='warningText'>
                            <span>
                                {Strings("searchedZones") +
                                    this.state.zonelist.join(", ")}
                            </span>
                        </Col>
                    </Row>
                )}
            </>
        );
    };
    handleSelectAll = () => {
        const { rows, selectAll } = this.state;

        if (selectAll) {
            // Unselect all
            this.setState({
                selectedRows: [],
                selectAll: false
            });
        } else {
            // Select all
            const allIds = rows.map(row => row.id);
            this.setState({
                selectedRows: allIds,
                selectAll: true
            });
        }
    };

    handleSelectRow = (id) => {
        this.setState(prevState => {
            const isSelected = prevState.selectedRows.includes(id);
            const selectedRows = isSelected
                ? prevState.selectedRows.filter(rowId => rowId !== id)
                : [...prevState.selectedRows, id];

            return {
                selectedRows,
                selectAll: selectedRows.length === prevState.rows.length
            };
        });
    };
    handleSendClick = () => {
        const { selectedRows, rows } = this.state;
        if (!selectedRows || selectedRows.length === 0) {
            return;
        }
        const minimartAndOwnerPhoneList = rows
            .filter(row => selectedRows.includes(row.id))
            .map(row => ({
                minimartId: row.id,
                ownerphone: row.ownerPhone || null
            }));

        const reqObj = {
            minimartAndOwnerPhoneList
        };
        this.props.sendMessageToMinimarts(reqObj, () => this.handleOnClickSearchFilter(true), ()=> this.setState({ selectedRows: [], selectAll: false }));
    };

    renderMinimartList = (rows, columns) => {
        const { selectedRows, selectAll } = this.state;

        return (
            <div className="mx-5">
                <Card className="mt-3 headerRow py-2">
                    <div className="d-flex w-100">
                        {columns.map((column) => (
                            <div
                                className="text-center"
                                key={column.key}
                                style={{ width: column.width }}
                            >

                                {column.key === "action" ? (
                                    <div className="">
                                        <Typography className="headerContent">
                                            {Strings(column.name)}
                                        </Typography>
                                        <div className="d-flex justify-content-center">

                                            <CheckboxComponent
                                                checked={selectAll}
                                                onChange={this.handleSelectAll}
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <Typography className="headerContent">
                                        {Strings(column.name)}
                                    </Typography>
                                )}
                            </div>
                        ))}
                    </div>
                </Card>

                {/* Rows */}
                {rows.map((row) => (
                    <Card
                        key={row.id}
                        className="tableRow py-1"
                        style={{ backgroundColor: "#FAFAFA" }}
                    >
                        <div className="d-flex w-100">
                            {columns.map((column) => (
                                <div
                                    className={`${column.key !== "ownerPhone" ? "text-center" : "ps-3"}`}
                                    key={column.key}
                                    title={Strings(column.name)}
                                    style={{ width: column.width }}
                                >
                                    {column.key === "action" ? (
                                        <div className="d-flex justify-content-center w-100">
                                            <CheckboxComponent
                                                checked={selectedRows.includes(row.id)}
                                                onChange={() => this.handleSelectRow(row.id)}
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <span className="content">
                                                {Strings(row[column.key] ?? "-")}
                                            </span>
                                            {column.key === "ownerPhone" && row.isWhatsAppNumber === true && <img
                                                className='ps-2'
                                                src={whatsapp_icon}
                                                alt='whatsapp_icon'
                                            />}
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    </Card>
                ))}
            </div>
        );
    };

    render() {

        return (
            <div className="customTableCard">
                {this.renderSearchFilter()}
                {this.state.rows?.length > 0 ? (
                    <>
                        {this.renderMinimartList(this.state.rows, this.columns)}
                        <Row className="pt-2 pe-4 justify-content-end">
                            <Col md={2}>
                                <Button
                                    className='capitalText buttonBackground pull-right mx-2'
                                    onClick={this.handleSendClick}
                                    disabled={this.state.selectedRows.length === 0}
                                >
                                    {Strings("Submit")}
                                </Button>

                            </Col>
                        </Row>
                        <Col md={11} className='noPadding alignPagination'>
                            <Pagination
                                activePage={this.state.activePage}
                                recordsPerPage={this.state.recordsPerPage}
                                numberOfPages={this.props.numberOfPages}
                                onPageChange={this.onPageChange}
                                dropup={true}
                            />
                        </Col>
                    </>
                ) : (
                    <div className='noRecordsFound'>
                        {Strings("NoRecordsFound")}
                    </div>
                )}
            </div>
        )
    }
}

export default WhatsappMinimartList;